import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { v4 as uuidv4 } from 'uuid';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { MenuInstitucionSedeOpcionTerminalFormSnp, OpcionTerminalFormSnp } from '@/shared/model/snp/opcion-terminal.model';
import { obtenerFechaHoyYYYYMMDD } from '@/shared/date/date-utils';

const validations = function () {
  const { opcionTerminalForm } = this as OpcionesTerminalesRegistroComponent;
  return {
    opcionTerminalForm: {
      descripcionOpcionTerminal: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(100),
      },
      fechaAlta: {
        required,
      },
      fechaBaja: {
        minValue: val => {
          return val != undefined && opcionTerminalForm.fechaAlta != undefined ? val >= opcionTerminalForm.fechaAlta : true;
        },
      },
      opcionTitulacion: {},
      instituciones: {
        required,
        minLength: minLength(1),
      },
    },
  };
};

@Component({
  validations: validations,
})
export default class OpcionesTerminalesRegistroComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return new OpcionTerminalFormSnp();
    },
  })
  public opcionTerminalEdicion: OpcionTerminalFormSnp;

  public fechaHoy = '';
  public opcionTerminalForm: OpcionTerminalFormSnp = new OpcionTerminalFormSnp();
  public instituciones: Array<MenuInstitucionSedeOpcionTerminalFormSnp> = [];

  public mounted(): void {
    this.iniciarComponente(false);
  }

  @Watch('opcionTerminalEdicion')
  public watchOpcionTerminalEdicion(): void {
    this.iniciarComponente(false);
  }

  public iniciarComponente(limpiarOpcionTerminal: boolean): void {
    this.fechaHoy = obtenerFechaHoyYYYYMMDD();
    this.instituciones = [];

    if (this.solicitud?.programa?.instituciones) {
      this.solicitud.programa.instituciones.forEach(institucion => {
        (institucion.sedes ?? []).forEach(sede => {
          const institucionSede = `${institucion.nombreInstitucion} || ${sede.nombreDependencia} (${sede.sede})`;
          this.instituciones.push({
            value: {
              claveInstitucion: institucion.claveInstitucion,
              claveDependencia: sede.claveDependencia,
              nombre: institucionSede,
            },
            text: institucionSede,
          });
        });
      });
    }

    if (this.opcionTerminalEdicion?.cveOpcionTerminal && !limpiarOpcionTerminal) {
      this.opcionTerminalForm = this.opcionTerminalEdicion;
    } else {
      this.opcionTerminalForm = new OpcionTerminalFormSnp();
      this.opcionTerminalForm.cveOpcionTerminal = uuidv4();
    }

    if (this.instituciones.length == 1 && this.opcionTerminalForm.instituciones.length == 0) {
      this.opcionTerminalForm.instituciones.push(this.instituciones[0].value);
    }
  }

  public limpiarDatos(): void {
    this.iniciarComponente(true);
  }

  public guardarOpcionTerminal(): void {
    if (!this.readOnly) {
      if (!this.formularioIsInvalid) {
        this.agregarOpcionTerminal();
      } else {
        this.alertService().showWarning(this, this.$t('apeironGwApp.opcionterminalSnp.form.formularioInvalido').toString());
      }
    }
  }

  @Emit('agregarOpcionTerminal')
  public agregarOpcionTerminal(): OpcionTerminalFormSnp {
    const opcionTerminal = { ...this.opcionTerminalForm };

    this.limpiarDatos();

    return opcionTerminal;
  }

  get formularioIsInvalid(): boolean {
    return this.$v.$invalid;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
